/**
 * Log level heirarchy.
 * @type {Object} 
 */
define('app-console/lib/levels',{
    none        : 10000,
    global      : 10000, //in case global gets through somehow
    error       : 40,
    exception   : 40,
    warn        : 30,
    info        : 20,
    dir         : 10,
    dirxml      : 10,
    debug       : 10,
    log         : 10
});
